import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';

import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { translate } from '@jsverse/transloco';

import { AlertService } from 'app/services/alert.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { QueryTopicService } from '../../services/query-topic.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-configuration-query-topics-purpose-dialog',
  templateUrl: './configuration-query-topics-purpose-dialog.component.html',
  styleUrls: ['./configuration-query-topics-purpose-dialog.component.scss'],
  standalone: false,
})
export class ConfigurationQueryTopicsPurposeDialogComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  formGroup: UntypedFormGroup;
  isGenerationInProgress = false;
  hasPurposeGenerationPermission = false;
  initialized = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      longPurpose: string;
      query: string;
      generateWithGPT?: boolean;
    },
    private matDialog: MatDialogRef<ConfigurationQueryTopicsPurposeDialogComponent>,
    private fb: FormBuilder,
    private alertService: AlertService,
    private queryTopicService: QueryTopicService
  ) {
    this.formGroup = this.fb.group({
      longPurpose: [this.data.longPurpose],
    });
  }

  ngOnInit(): void {
    this.queryTopicService.hasPurposeGenerationPermission().then((hasPermission) => {
      this.hasPurposeGenerationPermission = hasPermission;
      this.initialized = true;

      if (this.hasPurposeGenerationPermission && this.data.generateWithGPT) {
        this.onGenerate();
      }
    });
  }

  onCancel() {
    this.matDialog.close();
  }

  onGenerate() {
    this.isGenerationInProgress = true;
    this.formGroup.controls.longPurpose.disable();

    this.queryTopicService
      .generatePurpose(this.data.query)
      .then(
        (result) => this.formGroup.controls.longPurpose.setValue(result),
        (error: HttpErrorResponse | Error) =>
          this.alertService.showErrorToast(
            translate('configuration-query-topics-purpose-dialog-component.unable-to-generate'),
            error
          )
      )
      .finally(() => {
        this.isGenerationInProgress = false;
        this.formGroup.controls.longPurpose.enable();
      });
  }

  onSave() {
    this.matDialog.close(this.formGroup.controls.longPurpose.value);
  }
}
